import { componentTranslations, SpecificComponentTranslation } from './component-translations';
import type { InformativeComponentValue } from '../types';

type InformativeColor = InformativeComponentValue['color'];

export const informativeTypeToColor = (type: string): InformativeColor => {
	switch (type) {
		case 'tip': return 'green';
		case 'warning': return 'red';
		case 'important': return 'orange';
		case 'note': return 'blue';
		default: return 'green';
	}
};

export const informativeTypeToTitle = (
	type: keyof SpecificComponentTranslation,
	locale: string
): string => componentTranslations[locale][type];
